import { authorizedRequest } from './'

export const getSignedURL = async (id: string) => {
  try {
    const response = await authorizedRequest({
      method: 'GET',
      endpoint: `stream/${id}`,
    })
    const { data } = (await response.json()) as {
      success: true
      data: {
        streamUrl: string
        subtitles: any[] // prod subtitle files, so not the ones we want to preview?
      }
    }
    return data.streamUrl ? 'https://' + data.streamUrl : ''
  } catch (e) {
    throw e
  }
}
